// React 19 no longer applies defaultProps to functions. Preserve undefined/null
// semantics and defaults forwarded through rest props in the existing UI API.
export default function resolveDefaultProps(props, defaults) {
  const resolved = { ...props };
  for (const key of Object.keys(defaults)) {
    if (resolved[key] === undefined) resolved[key] = defaults[key];
  }
  return resolved;
}
